/* istanbul ignore file */
import 'core-js'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { ThemeProvider } from '@emotion/react'
import { getAPMServerUrl, getEnvironmentName } from 'utils/environmentUtil'
import theme from './theme'
import App from 'App'

import AnalyticsGateway from 'cec-commons-util-analytics-gateway'
import { BrowserRouter } from 'react-router-dom'
import store, { persistor } from 'store'
import { initializeClarity } from 'utils/clarityUtil'

import 'styles/main.scss'
import { dpprApiGet } from 'utils/http'
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk'
import { saveConfiguration } from 'store/actions/configurationAction'
import ErrorPage from 'pages/ErrorPage'
import useAppcues from 'utils/appcuesUtil'
import { init as initApm } from '@elastic/apm-rum'

const environment = getEnvironmentName()

if (environment !== 'dev-local') {
  const env = environment === 'development' ? 'dev' : environment
  initApm({
    serviceName: 'dppr-ui',
    serverUrl: getAPMServerUrl(),
    environment: env
  }).addLabels({
    organization: 'real_estate_aus',
    space: 'prp_engagement_tools',
    application: 'dppr-ui',
    environment: env
  })
}

(async function () {
  try {
    const { data: configData } = await dpprApiGet({ url: '/public/configuration' })

    AnalyticsGateway.initialize(configData.segmentKey)
    AnalyticsGateway.pageView()
    store.dispatch(saveConfiguration(configData))
    initializeClarity.initialize(configData.clarityKey)

    const LDProvider = await asyncWithLDProvider({ clientSideID: configData.launchDarklyKey })
    useAppcues({ id: configData.uniqueCookieId })

    ReactDOM.createRoot(document.getElementById('root')).render(
      <LDProvider>
        <ThemeProvider theme={theme}>
          <Provider store={store}>
            <PersistGate persistor={persistor}>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </PersistGate>
          </Provider>
        </ThemeProvider>
      </LDProvider>
    )
  } catch (e) {
    ReactDOM.createRoot(document.getElementById('root')).render(
      <ErrorPage />
    )
  }
})()
